const getCustomerProduct = (state) => {
	return state.customerProduct;
};

export default {
	getCustomerProduct
};
